<template>
  <modal
    :is-hidden="isHidden"
    :is-open="isOpen"
    :title="$t('ProjectDetails.addItem')"
    ref="modal"
    v-on:clickclose="closeDialog"
    :fixed="true"
  >

    <div class="product-addon-popup">
      <div class="product-image" v-html="item.image"></div>

      <div>
        <b class="ptop-15">{{ $t('Common.item') }}:</b>
        <div>{{ item.name }}</div>
      </div>

      <div class="ptop-15" v-if="item.description">
        <b>{{ $t('Common.description') }}:</b>
        <div>{{ item.description }}</div>
      </div>

      <div class="mtop-15">
        <b>{{ $t('Common.quantity') }}:</b>
        <quantityfield :value="item.amount" v-on:input="handleAmountInput"></quantityfield>
      </div>
    </div>

    <template slot="footer">
      <button type="button" class="btn btn-sm btn-danger float-left" v-if="isRemovable" v-on:click="removeItem">{{ $t('Action.remove') }}</button>
      <button type="button" class="btn btn-sm btn-default" v-on:click="closeDialog">{{ $t('Action.close') }}</button>
      <button type="button" class="btn btn-sm btn-success" v-on:click="addItem">{{ $t('Action.add') }}</button>
    </template>
  </modal>
</template>
<script>
var view = require('../view.js'),
    viewData = {
      item: {
        ID: null,
        itemnum: '',
        amount: 1,
        name: '',
        description: '',
        image: ''
      },
      isHidden: true,
      isOpen: false,
      isRemovable: false
    };

export default view(viewData, {
  methods: {
    openItem(item, removable) {
      console.log('openItem', item);
      this.item.ID = item.ID || item.item;
      this.item.name = item.name;
      this.item.itemnum = item.itemnum;
      this.item.description = item.description;
      this.item.amount = 1;

      this.isRemovable = typeof removable == 'undefined' ? false : removable;

      if (!item.image) {
        this.item.image = '<i class="fa fa-archive"></i>';
      } else {
        this.item.image = '<img alt="' +  item.itemnum + '" src="' + this.$root.url + 'item/img/' + this.item.ID + '" />';
      }

      this.openDialog();
    },
    addItem() {
      this.$emit('additem', JSON.parse(JSON.stringify(this.item)));
    },
    removeItem() {
      this.$emit('removeitem', JSON.parse(JSON.stringify(this.item)));
    },
    closeDialog() {
      this.$refs.modal.close(this);
    },
    openDialog() {
      this.$refs.modal.open(this);
    },
    handleAmountInput(amount) {
      this.item.amount = amount;
    }
  }
});
</script>
